import Base from 'base/control/textarea'

export default {
  Base,
}
